import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FadeLoader } from 'react-spinners';
import { fetchFiliales, fetchProveedorCarrocero, fetchUbicacionPedido, fetchSucursales, loadMantenimiento } from '../../actions';
import PageHeader from '../../components/PageHeader';
import Alert from '../../components/Alert';
import Paginacion from '../../components/Paginacion';
import Filtros from './Filtros';
import TablaMantenimiento from './TablaMantenimiento';
import Formulario from './Formulario';
import toggleDiv from '../../utils/toggleDiv';
import { createUbiPedido, editUbiPedido } from '../../utils/mantenimientoEntrega';

class MantDiasTraslado extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertErrorOpen: false,
      alertSuccessOpen: false,
      // filter
      sucursalFilter: '',
      sapFilter: '',
      // paginacion
      pagina: 1,
      totalRegistros: 0,
      cantidad: 0,
      // modal
      modalOpen: '',
      desUbiPed: '',
      sucursal: '',
      indCarrocero: '',
      provCarrocero: '',
      provCarroceroName: '',
      indInventario: '',
      indInactivo: false,
      disabledSelects: false,
      registroSelected: '',
      modalTitle: 'Crear registro',
      filial:'',
      filialFilter:'',
      buscar:'',
    };
  }

  componentDidMount() {
    document.addEventListener('click', toggleDiv, true);
    this.props.fetchSucursales();
    this.props.fetchFiliales();

    this.props.fetchUbicacionPedido()
      .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
        cantidad: data.listaUbicacionPedido.length }));
    this.props.fetchProveedorCarrocero();
  }

  componentWillUnmount() {
    document.removeEventListener('click', toggleDiv, true);
  }

  onChangeValue = e => this.setState({ [e.target.name]: e.target.value });
  onCheck = e => this.setState({ [e.target.name]: e.target.checked });

  onChangeAndFilter = (e) => {
    this.setState(
      { [e.target.name]: e.target.value },
      () => {
        const { sucursalFilter, sapFilter, pagina,filialFilter } = this.state;
        this.props.loadMantenimiento();
        this.props.fetchUbicacionPedido(sucursalFilter, sapFilter, filialFilter,pagina)
          .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
            cantidad: data.listaUbicacionPedido.length,
            pagina: 1 }));
      }
    );
  }

  onChangetext = (e) => {
    this.setState(
      { [e.target.name]: e.target.value });
  }

  createRegistro = () => {
    createUbiPedido(this.state)
      .then((response) => {
        const { sucursalFilter, sapFilter } = this.state;
        if (response.data.estadoTrama === '1') {
          this.showAlert('alertSuccessOpen');
          this.props.loadMantenimiento();
          this.props.fetchUbicacionPedido(sucursalFilter, sapFilter)
            .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
              cantidad: data.listaUbicacionPedido.length,
              pagina: 1 }));
        } else {
          this.showAlert('alertErrorOpen');
        }
        this.resetForm();
      })
      .catch((error) => {
        console.log(error);
        this.showAlert('alertErrorOpen');
        this.resetForm();
      });
  }

  editRegistro = (registro) => {
    editUbiPedido(this.state, registro)
      .then((response) => {
        const { sucursalFilter, sapFilter } = this.state;
        if (response.data.estadoTrama === '1') {
          this.showAlert('alertSuccessOpen');
          this.props.loadMantenimiento();
          this.props.fetchUbicacionPedido(sucursalFilter, sapFilter)
            .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
              cantidad: data.listaUbicacionPedido.length,
              pagina: 1 }));
        } else {
          this.showAlert('alertErrorOpen');
        }
        this.resetForm();
      })
      .catch((error) => {
        console.log(error);
        this.showAlert('alertErrorOpen');
        this.resetForm();
      });
  }

  closeAlertError = () => this.setState({ alertErrorOpen: false });
  closeAlertSuccess = () => this.setState({ alertSuccessOpen: false });

  showAlert = (alertType) => {
    this.setState({ [alertType]: true });
    setTimeout(() => this.setState({ [alertType]: false }), 5000);
  }

  closeModal = () => this.setState({ modalOpen: '' });
  openModal = modal => this.setState({ modalOpen: modal });

  selectProv = (key) => {
    this.setState({
      provCarrocero: key,
      provCarroceroName: this.props.proveedorCarrocero.listProveedorCarrocero
                          .filter(({ codPerso }) => codPerso === key)[0].nomPerso,
    });
  };

  backPag = () => {
    if (this.state.pagina === 1) return;
    this.setState(
      { pagina: this.state.pagina - 1 },
      () => {
        const { sucursalFilter, sapFilter, pagina ,filialFilter} = this.state;
        this.props.loadMantenimiento();
        this.props.fetchUbicacionPedido(sucursalFilter, sapFilter, filialFilter,pagina)
          .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
            cantidad: data.listaUbicacionPedido.length }));
      }
    );
  }

  nextPag = () => {
    if (this.state.pagina * 10 > this.state.totalRegistros) return;
    this.setState(
      { pagina: this.state.pagina + 1 },
      () => {
        const { sucursalFilter, sapFilter, pagina,filialFilter } = this.state;
        this.props.loadMantenimiento();
        this.props.fetchUbicacionPedido(sucursalFilter, sapFilter, filialFilter,pagina)
          .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
            cantidad: data.listaUbicacionPedido.length }));
      }
    );
  }

  openModalWithValues = (modal, mantenimiento) => {
    this.setState({
      modalOpen: modal,
      disabledSelects: true,
      modalTitle: 'Editar registro',
      desUbiPed: mantenimiento.desUbicaPedido || '',
      sucursal: mantenimiento.codSucursal || '',
      indCarrocero: mantenimiento.indCarrocero === 'SI',
      provCarrocero: mantenimiento.codProvCarro || '',
      provCarroceroName: mantenimiento.nomCarro || '',
      indInventario: mantenimiento.indInventario === 'SI',
      indInactivo: mantenimiento.indInactivo === 'NO',
      registroSelected: mantenimiento.codUbicaPedido,
      filial: mantenimiento.codFilial,
    });
  }

  filter = () => {
    const { sucursalFilter, sapFilter, pagina } = this.state;
    this.props.loadMantenimiento();
    this.props.fetchUbicacionPedido(sucursalFilter, sapFilter, pagina)
      .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
        cantidad: data.listaUbicacionPedido.length,
        pagina: 1 }));
    // document.querySelectorAll('.customToggle').forEach(dropdown => dropdown.classList.remove('open'));
      var lista=document.querySelectorAll('.customToggle');
      for (var i = 0; i < lista.length; i++) {
          lista[i].classList.remove('open')
      }
  }

  searchBuscar = () =>{
    const {  sucursalFilter, sapFilter, filialFilter,pagina, buscar } = this.state;
   
    this.props.loadMantenimiento();
    this.props.fetchUbicacionPedido(sucursalFilter, sapFilter, filialFilter,pagina,buscar)
      .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
        cantidad: data.listaUbicacionPedido.length,
        pagina: 1 }));
      
  }

  reset = () => {
    this.setState({
      sucursalFilter: '',
      sapFilter: '',
      filialFilter:'',
      buscar:'',
      pagina: 1,
    });
    this.props.loadMantenimiento();
    this.props.fetchUbicacionPedido()
      .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
        cantidad: data.listaUbicacionPedido.length }));
  }

  resetForm = () => {
    this.setState({
      modalOpen: '',
      desUbiPed: '',
      sucursal: '',
      indCarrocero: '',
      provCarrocero: '',
      provCarroceroName: '',
      indInventario: '',
      indInactivo: false,
      disabledSelects: false,
      registroSelected: '',
      modalTitle: 'Crear registro',
      filial:'',
    });
  }

  render() {
    const { filiales,mantenimientoEntrega, sucursales } = this.props;

    return (
      <div>
        <PageHeader title='Mantenimiento de Ubicacion de Pedido' openModal={this.openModal} buttonName='Nuevo registro' modalName='mantenimiento' />
        <Filtros
          sucursales={sucursales ? sucursales.sucursalResponse : []}
          sucursalFilter={this.state.sucursalFilter}
          searchBuscar = {this.searchBuscar}
          sapFilter={this.state.sapFilter}
          filialFilter = {this.state.filialFilter}
          buscar= {this.state.buscar}
          filiales = {filiales}
          onChangeValue={this.onChangeValue}
          onChangeAndFilter={this.onChangeAndFilter}
          onChangetext = {this.onChangetext}
          reset={this.reset}
          filter={this.filter}
        />
        <Paginacion
          paginas={this.state.totalRegistros}
          pagina={this.state.pagina}
          cantidad={this.state.cantidad}
          backPag={this.backPag}
          nextPag={this.nextPag}
        />
        <div className='wrapper'>
          <div className='tableWrapper'>
            <table className='table table-hover' style={{ marginBottom: '20px' }} >
              <thead className='table-head'>
                <tr>
                  <th>ID</th>
                  <th>Descripción de la ubicación del pedido</th>
                  <th>Sucursal</th>
                  <th>Filial</th>
                  <th>Indicador de carrocero</th>
                  <th>Proveedor de carrocero</th>
                  <th>Indicador de inventario</th>
                  <th>Código de ubica pedido para SAP</th>
                  <th>Indicador de inactividad</th>
                  <th />
                </tr>
              </thead>
              {
                mantenimientoEntrega ?
                  <TablaMantenimiento
                    lugares={mantenimientoEntrega.listaUbicacionPedido}
                    filiales = {filiales}
                    openModal={this.openModalWithValues}
                  /> :
                  <tbody>
                    <tr>
                      <td colSpan={9}><FadeLoader color={'#F8A14A'} loading /></td>
                    </tr>
                  </tbody>
              }
            </table>
          </div>
        </div>
        <Formulario
          isOpen={this.state.modalOpen === 'mantenimiento'}
          title={this.state.modalTitle}
          closeModal={this.resetForm}
          filiales={filiales}

          onChangeValue={this.onChangeValue}
          sucursales={sucursales ? sucursales.sucursalResponse : []}
          create={this.createRegistro}
          edit={this.editRegistro}
          disabled={this.state.disabledSelects}
          desUbiPed={this.state.desUbiPed}
          sucursal={this.state.sucursal}
          filial = {this.state.filial}
          indCarrocero={this.state.indCarrocero}
          provCarrocero={this.state.provCarrocero}
          provCarroceroName={this.state.provCarroceroName}
          indInventario={this.state.indInventario}
          indInactivo={this.state.indInactivo}
          registroSelected={this.state.registroSelected}
          onCheck={this.onCheck}
          selectProv={this.selectProv}
          listaProvCarrocero={
            this.props.proveedorCarrocero
              ? this.props.proveedorCarrocero.listProveedorCarrocero
              : []
          }
        />
        {
          this.state.alertErrorOpen &&
            <Alert type='alert-warning' icon='ion-alert-circled' closeAlert={this.closeAlertError}>
              <p>Hubo un error al guardar el registro</p>
            </Alert>
        }
        {
          this.state.alertSuccessOpen &&
            <Alert type='alert-success' icon='ion-checkmark-circled' closeAlert={this.closeAlertSuccess}>
              <p>Se guardó correctamente el registro</p>
            </Alert>
        }
        {
          (mantenimientoEntrega && mantenimientoEntrega.error) &&
            <Alert type='alert-danger' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar registros</p>
            </Alert>
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    proveedorCarrocero: state.proveedorCarrocero,
    mantenimientoEntrega: state.mantenimientoEntrega,
    sucursales: state.sucursales,
    filiales: state.filiales,

  };
}
MantDiasTraslado.defaultProps = {
  filiales: [],
};
export default connect(
  mapStateToProps,
  { fetchFiliales,fetchProveedorCarrocero, fetchUbicacionPedido, loadMantenimiento, fetchSucursales }
)(MantDiasTraslado);



// WEBPACK FOOTER //
// ./src/pages/MantUbicacionPedido/MantUbicacionPedido.js